import React from "react";

type Props = {
	/** the direction that the given size will affect */
	direction?: "horizontal" | "vertical";
	/** the theme of the divider. Whether it is going to be displayed in light or dark mode */
	theme?: "light" | "dark";
};

function Divider({ direction = "vertical", theme = "light" }: Props) {
	const borderColor = theme === "dark" ? "white" : "#ccc";
	const opacity = theme === "dark" ? 0.1 : 1;

	return (
		<div
			style={
				direction === "vertical"
					? {
							borderLeft: `1px solid ${borderColor}`,
							height: "100%",
							opacity,
					  }
					: {
							borderTop: `1px solid ${borderColor}`,
							width: "100%",
							opacity,
					  }
			}
		/>
	);
}

export default Divider;
